import { z } from 'zod';
import { MapEntity, mapEntitySchema } from 'app/agriculture/queries/types/geometry/MapEntity';
import {
    mockPolygonGeometry,
    PolygonGeometry,
    polygonGeometrySchema,
} from 'app/agriculture/queries/types/geometry/PolygonGeometry';
import {
    mockPointGeometry,
    PointGeometry,
    pointGeometrySchema,
} from 'app/agriculture/queries/types/geometry/PointGeometry';

export interface Yard extends MapEntity {
    id: string;

    creatorId: number;
    createdAt: Date;
    updatedAt: Date;

    name: string;

    geometry: PolygonGeometry;
    pole: PointGeometry;
}

export const yardSchema = mapEntitySchema.extend({
    id: z.string().uuid(),

    creatorId: z.number(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),

    name: z.string(),

    geometry: polygonGeometrySchema,
    pole: pointGeometrySchema,
});

export const mockYard = ({
    id = '76549937-85d6-45f2-80bd-37d8e5c2211d',

    creatorId = 1,
    createdAt = new Date(),
    updatedAt = new Date(),

    name = 'Mock Yard Name',

    geometry = mockPolygonGeometry(),
    pole = mockPointGeometry(),
}: Partial<Yard> = {}): Yard => ({
    id,

    creatorId,
    createdAt,
    updatedAt,

    name,

    geometry,
    pole,
});
